import Bahia from './Bahia';
import Black_Gradient from './Black_Gradient';
import Blue_Gradient from './Blue_Gradient';
import BottomPanel_Arrow from './BottomPanel_Arrow';
import BottomPanel_Close from './BottomPanel_Close';
import Brown_Gradient from './Brown_Gradient';
import Bucket from './Bucket';
import Check from './Check';
import ChevronDown from './ChevronDown';
import Class_Line from './Class_Line';
import Class_Point from './Class_Point';
import Class_Poligon from './Class_Poligon';
import Clear_Feature from './Clear_Feature';
import ClearFilter from './Clear_Filter';
import Close from './Close';
import ClosedEye from './ClosedEye';
import Colored_Scale from './Colored_Scale';
import ConfigureLabel from './ConfigureLabel';
import ConfigureLabel_Close from './ConfigureLabel_Close';
import ContextMenu_Arrow from './ContextMenu_Arrow';
import ContextMenu_BlueCheck from './ContextMenu_BlueCheck';
import ContextMenu_Check from './ContextMenu_Check';
import Controllers from './Controllers';
import Copy from './Copy';
import Create_Drawing from './Create_Drawing';
import Cross from './Cross';
import CSV from './CSV';
import Description from './Description';
import Download from './Download';
import DownloadAndGeoservices from './DownloadAndGeoservices';
import Dynamic_Labels from './DynamicLabels';
import Edit_Symbology from './Edit_Symbology';
import ExportFeature from './ExportFeature';
import Eye from './Eye';
import Filter from './Filter';
import FilterFeatures from './FilterFeatures';
import Fit from './Fit';
import Geoservice_ClearUrl from './Geoservice_ClearUrl';
import Geoservice_RequestArrow from './Geoservice_RequestArrow';
import GrabArea from './GrabArea';
import Green_Gradient from './Green_Gradient';
import InfoLayerImported from './InfoLayerImported';
import LabelMenu_FontBold from './LabelMenu_FontBold';
import LabelMenu_FontColor from './LabelMenu_FontColor';
import LabelMenu_FontSize from './LabelMenu_FontSize';
import LabelMenu_LabelAlignBottom from './LabelMenu_LabelAlignBottom';
import LabelMenu_LabelAlignHorizontalCenter from './LabelMenu_LabelAlignHorizontalCenter';
import LabelMenu_LabelAlignLeft from './LabelMenu_LabelAlignLeft';
import LabelMenu_LabelAlignRight from './LabelMenu_LabelAlignRight';
import LabelMenu_LabelAlignTop from './LabelMenu_LabelAlignTop';
import LabelMenu_LabelAlignVerticalCenter from './LabelMenu_LabelAlignVerticalCenter';
import LayersMenu_Layer from './LayersMenu_Layer';
import LayersMenu_Opacity from './LayersMenu_Opacity';
import LayersMenu_Plus from './LayersMenu_Plus';
import Legend from './Legend';
import LeiautePaisagem from './LeiautePaisagem';
import LeiauteRetrato from './LeiauteRetrato';
import Link from './Link';
import Menu from './Menu';
import MenuBars from './MenuBars';
import Minimize from './Minimize';
import Timeline from './Mosaic';
import North from './North';
import Opacity from './Opacity';
import PencilCut from './PencilCut';
import Print_HorizontalGridFake from './Print_HorizontalGridFake';
import Print_VerticalGridFake from './Print_VerticalGridFake';
import ReportMenu_Report from './ReportMenu_Report';
import Search from './Search';
import SideBySide from './SideBySide';
import SlimArrow from './SlimArrow';
import Swipeable from './Swipeable';
import Table from './Table';
import Tag from './Tag';
import ToolBar_BaseMap from './ToolBar_BaseMap';
import ToolBar_BoundFocus from './ToolBar_BoundFocus';
import ToolBar_Check from './ToolBar_Check';
import ToolBar_Clip from './ToolBar_Clip';
import ToolBar_Dissolve from './ToolBar_Dissolve';
import ToolBar_DrawByCoords from './ToolBar_DrawByCoords';
import ToolBar_ronmentalRestrictionReport from './ToolBar_EnvironmentalRestrictionReport';
import ToolBar_Erase from './ToolBar_Erase';
import ToolBar_Export from './ToolBar_Export';
import ToolBar_Import from './ToolBar_Import';
import ToolBar_Intersect from './ToolBar_Intersect';
import ToolBar_Line from './ToolBar_Line';
import ToolBar_List from './ToolBar_List';
import ToolBar_Marker from './ToolBar_Marker';
import ToolBar_Merge from './ToolBar_Merge';
import ToolBar_Plus from './ToolBar_Plus';
import ToolBar_Polygon from './ToolBar_Polygon';
import ToolBar_Print from './ToolBar_Print';
import ToolBar_Refresh from './ToolBar_Refresh';
import ToolBar_Ruler from './ToolBar_Ruler';
import ToolBar_SmallTrash from './ToolBar_SmallTrash';
import ToolBar_Trash from './ToolBar_Trash';
import ToolBar_Union from './ToolBar_Union';
import ToolBar_Update from './ToolBar_Update';
import Trash from './Trash';
import Upload from './Upload';
import ZoomIn from './ZoomIn';
import ZoomOut from './ZoomOut';

import dot from 'dot-object';

const iconsMap = {
  bahia: Bahia,
  check: Check,
  cross: Cross,
  clearFilter: ClearFilter,
  close: Close,
  copy: Copy,
  createDrawing: Create_Drawing,
  closedeye: ClosedEye,
  controllers: Controllers,  
  configureLabel: ConfigureLabel,
  configureLabelClose: ConfigureLabel_Close,
  chevrondown: ChevronDown,
  csv: CSV,
  description: Description,
  download: Download,
  downloadandgeoservices: DownloadAndGeoservices,
  editSymbology: Edit_Symbology,
  exportFeature: ExportFeature,
  eye: Eye,
  fit: Fit,
  filter: Filter,
  FilterFeatures: FilterFeatures,
  Clear_Feature: Clear_Feature,
  grabarea: GrabArea,
  infoLayerImported: InfoLayerImported,
  legend: Legend,
  leiautepaisagem: LeiautePaisagem,
  leiauteretrato: LeiauteRetrato,
  menu: Menu,
  menubars: MenuBars,
  timeline: Timeline,
  north: North,
  pencilCut: PencilCut,
  opacity: Opacity,
  swipeable: Swipeable,
  search: Search,
  sideBySide: SideBySide,
  slimarrow: SlimArrow,
  table: Table,
  trash: Trash,
  tag: Tag,
  link: Link,
  upload: Upload,
  contextmenu: {
    check: ContextMenu_Check,
    bluecheck: ContextMenu_BlueCheck,
    arrow: ContextMenu_Arrow,
  },
  bottompanel: {
    arrow: BottomPanel_Arrow,
    close: BottomPanel_Close,
  },
  toolbar: {
    drawbycoords: ToolBar_DrawByCoords,
    plus: ToolBar_Plus,
    trash: ToolBar_Trash,
    smalltrash: ToolBar_SmallTrash,
    list: ToolBar_List,
    update: ToolBar_Update,
    line: ToolBar_Line,
    ruler: ToolBar_Ruler,
    polygon: ToolBar_Polygon,
    check: ToolBar_Check,
    marker: ToolBar_Marker,
    boundfocus: ToolBar_BoundFocus,
    print: ToolBar_Print,
    report: ToolBar_ronmentalRestrictionReport,
    Minimize: Minimize,
    ZoomIn: ZoomIn,
    ZoomOut: ZoomOut,
    import: ToolBar_Import,
    export: ToolBar_Export,
    basemap: ToolBar_BaseMap,
    refresh: ToolBar_Refresh,
    intersect: ToolBar_Intersect,
    merge: ToolBar_Merge,
    union: ToolBar_Union,
    dissolve: ToolBar_Dissolve,
    dynamic: Dynamic_Labels,
    clip: ToolBar_Clip,
    erase: ToolBar_Erase,
  },
  layersmenu: {
    layer: LayersMenu_Layer,
    plus: LayersMenu_Plus,
    opacity: LayersMenu_Opacity,
  },
  reportmenu: {
    report: ReportMenu_Report,
  },
  labelmenu: {
    fontbold: LabelMenu_FontBold,
    fontcolor: LabelMenu_FontColor,
    fontsize: LabelMenu_FontSize,
    labelalignleft: LabelMenu_LabelAlignLeft,
    labelalignhorizontalcenter: LabelMenu_LabelAlignHorizontalCenter,
    labelalignright: LabelMenu_LabelAlignRight,
    labelaligntop: LabelMenu_LabelAlignTop,
    labelalignverticalcenter: LabelMenu_LabelAlignVerticalCenter,
    labelalignbottom: LabelMenu_LabelAlignBottom,
  },
  geoservice: {
    clearurl: Geoservice_ClearUrl,
    requestarrow: Geoservice_RequestArrow,
  },
  editsymbology: {
    colorful: Colored_Scale,
    bluegradient: Blue_Gradient,
    bucket: Bucket,
    greengradient: Green_Gradient,
    browngradient: Brown_Gradient,
    blackgradient: Black_Gradient,
    classline: Class_Line,
    classpoint: Class_Point,
    classpoligon: Class_Poligon,
  },
  print: {
    horizontalgridfake: Print_HorizontalGridFake,
    verticalgridfake: Print_VerticalGridFake,
  }
};

const Icon = ({ i, ...props }) => {
  const splittedReference = i.split('-');
  if (splittedReference[0] !== 'map') {
    return <p>Ícone não existe</p>;
  } else {
    splittedReference.shift();
    const IconComponent = dot.pick(splittedReference.join('.'), iconsMap);
    if (IconComponent) {
      return <IconComponent {...props} />;
    } else {
      return <p>Ícone não existe</p>;
    }
  }
};

export default Icon;
export {
  Bahia,
  Black_Gradient,
  Blue_Gradient,
  Brown_Gradient,
  Bucket,
  Class_Line,
  Class_Point,
  Class_Poligon,
  Search,
  SlimArrow,
  Edit_Symbology,
  ExportFeature,
  Eye,
  ClearFilter,
  ClosedEye,
  ConfigureLabel,
  Colored_Scale,
  Controllers,
  ChevronDown,
  Close,
  Create_Drawing,
  CSV,
  Download,
  DownloadAndGeoservices,
  Fit,
  Filter,
  FilterFeatures,
  Clear_Feature,
  InfoLayerImported,
  Table,
  Trash,
  Legend,
  LeiautePaisagem,
  LeiauteRetrato,
  Link,
  Tag,
  Check,
  Cross,
  GrabArea,
  Green_Gradient,
  Description,
  Menu,
  MenuBars,
  Timeline,
  North,
  Opacity,
  PencilCut,
  Swipeable,
  ZoomIn,
  ZoomOut,
  Upload,
  ContextMenu_Arrow,
  ContextMenu_BlueCheck,
  ContextMenu_Check,
  BottomPanel_Arrow,
  BottomPanel_Close,
  ToolBar_DrawByCoords,
  ToolBar_Plus,
  ToolBar_Trash,
  ToolBar_List,
  ToolBar_Update,
  ToolBar_Intersect,
  ToolBar_Import,
  ToolBar_Union,
  ToolBar_Dissolve,
  Dynamic_Labels,
  ToolBar_Export,
  ToolBar_BaseMap,
  ToolBar_Refresh,
  ToolBar_Line,
  ToolBar_Ruler,
  ToolBar_Polygon,
  ToolBar_Print,
  ToolBar_ronmentalRestrictionReport,
  ToolBar_Check,
  ToolBar_Marker,
  ToolBar_Merge,
  ToolBar_BoundFocus,
  ToolBar_Clip,
  ToolBar_Erase,
  LayersMenu_Layer,
  LayersMenu_Plus,
  LayersMenu_Opacity,
  Print_HorizontalGridFake,
  Print_VerticalGridFake,  
  ReportMenu_Report,
  Geoservice_ClearUrl,
  Geoservice_RequestArrow,
  LabelMenu_FontBold,
  LabelMenu_FontColor,
  LabelMenu_FontSize,
  LabelMenu_LabelAlignLeft,
  LabelMenu_LabelAlignHorizontalCenter,
  LabelMenu_LabelAlignRight,
  LabelMenu_LabelAlignTop,
  LabelMenu_LabelAlignVerticalCenter,
  LabelMenu_LabelAlignBottom,  
  Minimize
};

Icon.properties = {
  ignore: true,
};
